import BaseSelectBox from 'components/atoms/base-select-box';
import { useMemo } from 'react';
import { overviewDashboardSortDataSource } from 'infrastructure/data-sources/overview-dashboard-sort';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IOverviewDashboardSortItem } from 'infrastructure/data-sources/overview-dashboard-sort';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { OverviewDashboardSortEnum } from 'infrastructure/enums';
import type { FC } from 'react';

type Options = IBaseSelectBoxOption<
  IOverviewDashboardSortItem['id'],
  IOverviewDashboardSortItem
>[];

interface SortSelectBoxProps
  extends Omit<IBaseSelectBoxProps<OverviewDashboardSortEnum>, 'options'> {
  withNone?: boolean;
}

const SortSelectBox: FC<SortSelectBoxProps> = (props) => {
  const { withNone } = props;
  const { t } = useTranslation();
  const dataSource = useMemo(
    () => overviewDashboardSortDataSource(withNone),
    [withNone],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return (
    <div className={s.wrapper}>
      <label htmlFor="overview-dashboard-sort" className={s.label}>
        {t('overviewDashboardSort.label')}
      </label>
      <div>
        <BaseSelectBox
          options={options}
          id="overview-dashboard-sort"
          {...props}
        />
      </div>
    </div>
  );
};
export default SortSelectBox;
